import { gql, useMutation } from 'urql';

export const CREATE_USER = gql`
  mutation CreateUser($input: ExternalParticipant!) {
    createParticipant(input: $input) {
      success
      errorsData {
        firstName
        lastName
        phone
        email
        errorText
      }
      successIds
    }
  }
`;

export interface CreateEmployeeVariables {
  input: {
    email: string;
    phone: string;
    firstName: string;
    lastName: string;
  }[];
}

export interface ErrorData {
  firstName?: string;
  lastName?: string;
  phone?: string;
  email?: string;
  errorText?: string;
}

export interface CreateEmployeeResponse {
  createParticipant: {
    success: string;
    errorsData?: ErrorData[];
    successIds: string[];
  };
}

export const useCreateUser = () => {
  const [{ data, error }, executeMutation] = useMutation<CreateEmployeeResponse, CreateEmployeeVariables>(CREATE_USER);

  const createUser = (input: CreateEmployeeVariables) => {
    return executeMutation(input);
  };

  return { data, error, createUser };
};
